export function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  return fetch(url, {
    headers: {
      "Content-Type": "application/json",
    },
    ...init,
  }).then((response) => {
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    return response.json() as Promise<T>;
  });
}

export function postJson<T>(url: string, body: {} | []): Promise<T> {
  return fetchJson<T>(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(body),
  });
}

export function deleteJson<T>(url: string, body: {} | []): Promise<T> {
  return fetchJson<T>(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(body),
  });
}

export function postFormData<T>(url: string, formData: FormData): Promise<T> {
  return fetch(url, {    
    method: "POST",
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: formData,
  }).then((response) => {
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    return response.json() as Promise<T>;
  });
}


export function postJsonWithResponse(url: string, body: {} | []): Promise<Response> {
  return fetch(url, {
    method: "POST",
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  }).catch(() => null);
}

export function deleteJsonWithResponse(url: string, body: {} | []): Promise<Response> {
  return fetch(url, {
    method: "DELETE",
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  }).catch(() => null);
}

export function getJson<T>(url: string): Promise<T> {
  return fetchJson<T>(url, {
    method: "GET",
  });
}
